import React, { useState, useEffect } from 'react';
import { Bell, Search, User, Menu, X } from 'react-feather';
import '../../responsive.css';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

const Header = ({ toggleSidebar }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { userFirebase } = useContext(AuthContext);
  
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const handleUserMenuToggle = () => {
    setShowUserMenu(!showUserMenu);
    if (showNotifications) setShowNotifications(false);
  };
  
  const handleNotificationsToggle = () => {
    setShowNotifications(!showNotifications);
    if (showUserMenu) setShowUserMenu(false);
  };
  
  // Fechar menus ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserMenu || showNotifications) {
        if (!event.target.closest('.user-dropdown') && !event.target.closest('.notifications-dropdown')) {
          setShowUserMenu(false);
          setShowNotifications(false);
        }
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showUserMenu, showNotifications]);
  
  // Obter usuário do localStorage (simulação)
  const usuario = JSON.parse(localStorage.getItem('usuarioLogado')) || {
    nome: 'Usuário',
    cargo: 'Convidado'
  };
  
  // Iniciais do nome para avatar
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };
  
  return (
    <div className="header">
      <div className="header-left">
        <button className="header-toggle" onClick={toggleSidebar}>
          <Menu size={20} />
        </button>
      </div>
      
      <div className="header-right">
        {/* <div className="header-icon" onClick={handleNotificationsToggle}>
          <Bell size={20} />
          <span className="badge">3</span>
          
          {showNotifications && (
            <div className="dropdown-menu notifications-dropdown show">
              <div className="dropdown-header">
                <h6>Notificações</h6>
                <a href="#" className="text-muted">Marcar todas como lidas</a>
              </div>
              <div className="dropdown-body">
                <a href="#" className="dropdown-item">
                  <div className="notification-icon bg-primary">
                    <User size={16} />
                  </div>
                  <div className="notification-content">
                    <p>Novo cliente cadastrado</p>
                    <small className="text-muted">Há 5 minutos</small>
                  </div>
                </a>
                <a href="#" className="dropdown-item">
                  <div className="notification-icon bg-success">
                    <Bell size={16} />
                  </div>
                  <div className="notification-content">
                    <p>Contrato assinado por cliente</p>
                    <small className="text-muted">Há 1 hora</small>
                  </div>
                </a>
                <a href="#" className="dropdown-item">
                  <div className="notification-icon bg-warning">
                    <Bell size={16} />
                  </div>
                  <div className="notification-content">
                    <p>Pagamento pendente</p>
                    <small className="text-muted">Há 3 horas</small>
                  </div>
                </a>
              </div>
              <div className="dropdown-footer">
                <a href="#">Ver todas as notificações</a>
              </div>
            </div>
          )}
        </div> */}
        
        <div className="user-dropdown">
          <div className="user-dropdown-toggle" onClick={handleUserMenuToggle}>
            <div className="user-avatar">
              {getInitials(userFirebase?.name || usuario.nome)}
            </div>
            <div className="user-name">{userFirebase?.name}</div>
          </div>
          
          {showUserMenu && (
            <div className="user-dropdown-menu show">
              {/* <a href="#" className="user-dropdown-item">
                <User className="user-dropdown-icon" size={16} />
                Meu Perfil
              </a>
              <a href="#" className="user-dropdown-item">
                <Bell className="user-dropdown-icon" size={16} />
                Configurações
              </a> */}
              <hr className="dropdown-divider" />
              <a href="/login" className="user-dropdown-item text-danger">
                <X className="user-dropdown-icon" size={16} />
                Sair
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
